import styled from "styled-components"

export const StyledEditNutrientForm = styled.div`
  height: 100%;
  min-height: max(100dvh, 470px);
  background: var(--Schemes-Surface-Surface-Container-Low, #f5f7f7);
  display: flex;
  flex-direction: column;
`

export const EditNutrientFormHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 0 var(--spacing_l, 16px);
  height: 44px;
`

export const EditNutrientFormTitle = styled.div`
  color: var(--Schemes-Surface-On-surface-On-Surface, #1c1f21);
  font-size: 16px;
  font-weight: 600;
  line-height: 160%;
`

export const EditNutrientDescription = styled.p`
  padding: 0px 24px;
  margin: 8px 0;
  line-height: 22px;
  font-size: 14px;

  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
`

export const StrongNutrientInfo = styled.span`
  font-weight: 600;
`

export const CaloriesError = styled.p`
  font-size: 14px;
  color: #f1a100;
  text-align: right;
  margin-top: -4px;
`

export const EditNutritionConfirmText = styled.div`
  text-align: center;
  margin: 0 auto;
`
export const EditNutrientBottomDescriptionBox = styled.div`
  display: flex;
  padding: var(--spacing_l, 16px) var(--spacing_xl, 24px);
  align-items: center;
  gap: 10px;
  align-self: stretch;
`

export const EditNutrientBottomDescription = styled.p`
  color: var(--Schemes-Surface-On-surface-On-Surface-Variant-2, #69757d);
  font-size: 14px;
`
